import { type GenericFreedrawElement } from '..';
import { getBoundsFromPoints } from '../../../utils/editor/bounds';
import { type Point } from '../../../utils/math';

export const getFreeDrawElementAbsoluteCoordsFromPoints = (
  points: Point[],
  x: number,
  y: number,
): [number, number, number, number, number, number] => {
  const [minX, minY, maxX, maxY] = getBoundsFromPoints(points);
  const x1 = minX + x;
  const y1 = minY + y;
  const x2 = maxX + x;
  const y2 = maxY + y;
  return [x1, y1, x2, y2, (x1 + x2) / 2, (y1 + y2) / 2];
};

export const getFreeDrawElementAbsoluteCoords = (
  element: GenericFreedrawElement,
): [number, number, number, number, number, number] => {
  return getFreeDrawElementAbsoluteCoordsFromPoints(
    element.points,
    element.x,
    element.y,
  );
};
